import { HIDE_PIN_FORM, SHOW_PIN_FORM } from './constants';
import {
  PLAYER_MODALS_Z_INDEX_DECREASE,
  PLAYER_MODALS_Z_INDEX_INCREASE,
} from '../../Player/actions/optionButtons/constants';

export const showPinForm = params => dispatch => {
  dispatch({
    type: PLAYER_MODALS_Z_INDEX_INCREASE,
  });
  dispatch({
    type: SHOW_PIN_FORM,
    params,
  });
};

export const hidePinForm = () => (dispatch, getState) => {
  const state = getState();
  if (state?.PinForm?.show) {
    dispatch({
      type: PLAYER_MODALS_Z_INDEX_DECREASE,
    });
    dispatch({
      type: HIDE_PIN_FORM,
    });
  }
};
